module.exports = __webpack_public_path__ + "assets/img/1017.3b843191.svg";